<script setup lang="ts">
    import { computed } from 'vue';

    type Props = {
        size?: string;
        tooltipPosition?: string;
        type: string;
    };

    const props = withDefaults(defineProps<Props>(), {
        size: 'is-small',
        tooltipPosition: 'is-left'
    });

    const normalizedType = computed(() => props.type.toLowerCase());

    const icon = computed(() => {
        switch (normalizedType.value) {
            case 'global': return 'earth';
            case 'facility': return 'factory';
            case 'virtual': return 'alpha-v-circle';
            case 'uppercase': return 'alphabetical-variant';
            case 'readonly': return 'lock';
            case 'relation': return 'relation-many-to-many';
            default: return 'help-circle';
        }
    });

    const tooltip = computed(() => {
        switch (normalizedType.value) {
            case 'global': return 'Global';
            case 'facility': return 'Scoped by Facility';
            case 'virtual': return 'Virtual library';
            case 'uppercase': return 'Names uppercase only';
            case 'readonly': return 'Read-only in CommonLibrary';
            case 'relation': return 'Relation library';
            default: return '?';
        }
    });
</script>

<template>
    <b-tooltip
        :label="tooltip"
        :position="props.tooltipPosition"
        :size="props.size"
        animated>
        <b-icon
            :size="props.size"
            type="is-info"
            :icon="icon" />
    </b-tooltip>
</template>
